import { TabPanel } from '@mui/lab';
import { CircularProgress, Paper, Stack, Typography } from '@mui/material';
import { Protect } from 'app/components';
import { MapTransportBroadcast, MapTransportBroadcastList } from 'app/pages/Map';
import React from 'react';

const TabPanelBroadcast = ({ isFetchBroadcastLoading, transportSelectedItem }) => {
  return (
    <TabPanel value='broadcast'>
      {['onlyWialon'].includes(config.transportDeviceTypes[transportSelectedItem.device_type]) ? (
        <React.Fragment>
          <Stack
            direction='column'
            alignItems='center'
            justifyContent='center'
            sx={(theme) => ({
              width: '100%',
              height: '100%',
              padding: theme.spacing(2),
            })}>
            <Typography align='center' variant='body1' component='span'>
              Раздел недоступен
            </Typography>
            <Typography align='center' color='text.secondary' variant='caption' component='span'>
              Для текущего типа транспортного средства раздел недоступен
            </Typography>
          </Stack>
        </React.Fragment>
      ) : (
        <Protect
          permissions='broadcast'
          renderPermitted={() => (
            <React.Fragment>
              {!isFetchBroadcastLoading && transportSelectedItem.broadcast.terid.length !== 0 && (
                <Stack
                  direction='row'
                  sx={(theme) => ({
                    height: '100%',
                    borderTop: '1px solid',
                    borderColor: theme.palette.divider,
                    '& > .MuiPaper-root:first-of-type': {
                      minWidth: '200px',
                      borderRadius: '0',
                      borderRight: '1px solid',
                      borderColor: theme.palette.divider,
                    },
                    '& > .MuiPaper-root:last-of-type': {
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      bgcolor: 'background.default',
                      borderRadius: '0',
                    },
                  })}>
                  <Paper elevation={0}>
                    <MapTransportBroadcastList />
                  </Paper>
                  <Paper elevation={0}>
                    <MapTransportBroadcast />
                  </Paper>
                </Stack>
              )}
              {!isFetchBroadcastLoading && transportSelectedItem.broadcast.terid.length === 0 && (
                <Stack
                  direction='column'
                  alignItems='center'
                  justifyContent='center'
                  sx={(theme) => ({
                    width: '100%',
                    height: '100%',
                    padding: theme.spacing(2),
                  })}>
                  <Typography align='center' variant='body1' component='span'>
                    Здесь пока ничего нет
                  </Typography>
                  <Typography align='center' color='text.secondary' variant='caption' component='span'>
                    В этом разделе будут находиться видео транспорта
                  </Typography>
                </Stack>
              )}
              {isFetchBroadcastLoading && (
                <Stack
                  direction='column'
                  alignItems='center'
                  justifyContent='center'
                  sx={(theme) => ({
                    width: '100%',
                    height: '100%',
                    padding: theme.spacing(2),
                  })}>
                  <CircularProgress size={24} />
                </Stack>
              )}
            </React.Fragment>
          )}
          renderForbidden={() => (
            <React.Fragment>
              <Stack
                direction='column'
                alignItems='center'
                justifyContent='center'
                sx={(theme) => ({
                  width: '100%',
                  height: '100%',
                  padding: theme.spacing(2),
                })}>
                <Typography align='center' variant='body1' component='span'>
                  Доступ ограничен
                </Typography>
                <Typography align='center' color='text.secondary' variant='caption' component='span'>
                  Под вашей учетной записью доступ ограничен
                </Typography>
              </Stack>
            </React.Fragment>
          )}
        />
      )}
    </TabPanel>
  );
};

export default TabPanelBroadcast;
